import { render, staticRenderFns } from "./jfpg-pie-charts.vue?vue&type=template&id=4aa94982"
import script from "./jfpg-pie-charts.vue?vue&type=script&lang=js"
export * from "./jfpg-pie-charts.vue?vue&type=script&lang=js"
import style0 from "./jfpg-pie-charts.vue?vue&type=style&index=0&id=4aa94982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports